/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { ArrowLeft, Plus, MessageSquare } from "lucide-react";
import RenderSupportPage from "../RenderSupportPage";
import Member360Panel from "../components/Member360Panel";
import MemberProfileSkeleton from "../components/MemberProfileSkeleton";
import { supportActionCreators } from "../../services/Actions";

// Standalone member view — the same panel used beside a ticket, given the full
// width so an agent can browse history without a ticket in hand.

function MemberProfile360() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { GetMember360, GetMemberTickets, ClearTicketDetailed } =
    bindActionCreators(supportActionCreators, dispatch);

  const support = useSelector((state) => state.support);
  const { member360, memberTickets, isLoading } = support;

  const staffId = new URLSearchParams(location.search).get("staff_id");

  // `isLoading` is shared across the whole support slice and flips for other
  // calls too, so the skeleton is gated on "no member loaded yet" instead —
  // that way a background refresh never blanks a populated profile.
  const [hasLoaded, setHasLoaded] = useState(false);
  const profileLoaded = !!(member360?.profile?.staff_id || member360?.profile?.name);

  useEffect(() => {
    setHasLoaded(false);
    if (staffId) {
      Promise.all([GetMember360(staffId), GetMemberTickets(staffId)]).finally(
        () => setHasLoaded(true)
      );
    } else {
      setHasLoaded(true);
    }
    return () => ClearTicketDetailed();
  }, [staffId]);

  const showSkeleton = !hasLoaded && !profileLoaded;

  return (
    <RenderSupportPage title="Member Profile">
      <div className="flex items-center justify-between -mt-4 mb-4">
        <button
          onClick={() => history.push("/support/members")}
          className="flex items-center gap-1.5 text-xs font-semibold text-slate-500 dark:text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400"
        >
          <ArrowLeft size={14} /> Back to members
        </button>
        <div className="flex items-center gap-2">
          <button
            onClick={() => history.push("/support/messages")}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-lg border border-slate-200 dark:border-gray-600 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-gray-700"
          >
            <MessageSquare size={13} /> Messages
          </button>
          <button
            onClick={() => history.push("/support/tickets")}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm"
          >
            <Plus size={13} /> New Ticket
          </button>
        </div>
      </div>

      {showSkeleton ? (
        <MemberProfileSkeleton />
      ) : (
        <Member360Panel member360={member360} memberTickets={memberTickets} />
      )}
    </RenderSupportPage>
  );
}

export default MemberProfile360;
